// FETCH ALL PROPERTIES FROM STITCHING_DC DETAILS
export const FETCH_STITCHING_DC_DETAILS_REQUEST = 'FETCH_STITCHING_DC_DETAILS_REQUEST';
export const FETCH_STITCHING_DC_DETAILS_SUCCESS = 'FETCH_STITCHING_DC_DETAILS_SUCCESS';
export const FETCH_STITCHING_DC_DETAILS_FAILURE = 'FETCH_STITCHING_DC_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM STITCHING_DC DETAILS
export const FETCH_STITCHING_DC_DETAILS_FIRST_GRID_REQUEST = 'FETCH_STITCHING_DC_DETAILS_FIRST_GRID_REQUEST';
export const FETCH_STITCHING_DC_DETAILS_FIRST_GRID_SUCCESS = 'FETCH_STITCHING_DC_DETAILS_FIRST_GRID_SUCCESS';
export const FETCH_STITCHING_DC_DETAILS_FIRST_GRID_FAILURE = 'FETCH_STITCHING_DC_DETAILS_FIRST_GRID_FAILURE';

// FETCH ALL PROPERTIES FROM STITCHING_DC DETAILS
export const FETCH_STITCHING_DC_DETAILS_SECOND_GRID_REQUEST = 'FETCH_STITCHING_DC_DETAILS_SECOND_GRID_REQUEST';
export const FETCH_STITCHING_DC_DETAILS_SECOND_GRID_SUCCESS = 'FETCH_STITCHING_DC_DETAILS_SECOND_GRID_SUCCESS';
export const FETCH_STITCHING_DC_DETAILS_SECOND_GRID_FAILURE = 'FETCH_STITCHING_DC_DETAILS_SECOND_GRID_FAILURE';

// FETCH ALL PROPERTIES FROM STITCHING_DC DETAILS BY ID
export const FETCH_STITCHING_DC_DETAILS_BY_ID_REQUEST = 'FETCH_STITCHING_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_STITCHING_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_STITCHING_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_STITCHING_DC_DETAILS_BY_ID_FAILURE = 'FETCH_STITCHING_DC_DETAILS_BY_ID_FAILURE';

// FETCH ALL PROPERTIES FROM STITCHING_DC DETAILS BY ID
export const FETCH_STITCHING_DC_DETAILS_DN_BY_ID_REQUEST = 'FETCH_STITCHING_DC_DETAILS_DN_BY_ID_REQUEST';
export const FETCH_STITCHING_DC_DETAILS_DN_BY_ID_SUCCESS = 'FETCH_STITCHING_DC_DETAILS_DN_BY_ID_SUCCESS';
export const FETCH_STITCHING_DC_DETAILS_DN_BY_ID_FAILURE = 'FETCH_STITCHING_DC_DETAILS_DN_BY_ID_FAILURE';

// CREATE PROPERTIES FOR STITCHING_DC DETAILS
export const CREATE_STITCHING_DC_DETAILS_REQUEST = 'CREATE_STITCHING_DC_DETAILS_REQUEST';
export const CREATE_STITCHING_DC_DETAILS_SUCCESS = 'CREATE_STITCHING_DC_DETAILS_SUCCESS';
export const CREATE_STITCHING_DC_DETAILS_FAILURE = 'CREATE_STITCHING_DC_DETAILS_FAILURE';

// CREATE PROPERTIES FOR STITCHING_DC DETAILS
export const CREATE_STITCHING_DC_DETAILS2_REQUEST = 'CREATE_STITCHING_DC_DETAILS2_REQUEST';
export const CREATE_STITCHING_DC_DETAILS2_SUCCESS = 'CREATE_STITCHING_DC_DETAILS2_SUCCESS';
export const CREATE_STITCHING_DC_DETAILS2_FAILURE = 'CREATE_STITCHING_DC_DETAILS2_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_STITCHING_DC_DETAILS = 'CREATE_USER_FORM_STITCHING_DC_DETAILS';

// UPDATE PROPERTIES FOR STITCHING_DC DETAILS
export const UPDATE_STITCHING_DC_DETAILS_REQUEST = 'UPDATE_STITCHING_DC_DETAILS_REQUEST';
export const UPDATE_STITCHING_DC_DETAILS_SUCCESS = 'UPDATE_STITCHING_DC_DETAILS_SUCCESS';
export const UPDATE_STITCHING_DC_DETAILS_FAILURE = 'UPDATE_STITCHING_DC_DETAILS_FAILURE';

// FETCH SINGLE STITCHING_DC_DETAILS
export const FETCH_SINGLE_STITCHING_DC_DETAILS_REQUEST = 'FETCH_SINGLE_STITCHING_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_STITCHING_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_STITCHING_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_STITCHING_DC_DETAILS_FAILURE = 'FETCH_SINGLE_STITCHING_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR STITCHING_DC DETAILS
export const DELETE_STITCHING_DC_DETAILS_REQUEST = 'DELETE_STITCHING_DC_DETAILS_REQUEST';
export const DELETE_STITCHING_DC_DETAILS_SUCCESS = 'DELETE_STITCHING_DC_DETAILS_SUCCESS';
export const DELETE_STITCHING_DC_DETAILS_FAILURE = 'DELETE_STITCHING_DC_DETAILS_FAILURE';

export const FETCH_STITCHING_DC_PREVIOUS_LIST_REQUEST = 'FETCH_STITCHING_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_STITCHING_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_STITCHING_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_STITCHING_DC_PREVIOUS_LIST_FAILURE = 'FETCH_STITCHING_DC_PREVIOUS_LIST_FAILURE';

// USERFORM RESET

export const STITCHING_DC_DETAILS_USERFORM_RESET = 'STITCHING_DC_DETAILS_USERFORM_RESET';

export const CREATE_USER_FORM_STITCHING_DC_EDIT_QTY = 'CREATE_USER_FORM_STITCHING_DC_EDIT_QTY';
export const CREATE_USER_FORM_STITCHING_DC_SECOND_GRID_EDIT_QTY = 'CREATE_USER_FORM_STITCHING_DC_SECOND_GRID_EDIT_QTY';

export const RESET_STITCHING_DC_EDIT_QTY_V2 = 'RESET_STITCHING_DC_EDIT_QTY_V2';
export const RESET_STITCHING_DC_SECOND_GRIG_EDIT_QTY_V2 = 'RESET_STITCHING_DC_SECOND_GRIG_EDIT_QTY_V2';


export const CREATE_USER_FORM_STITCHING_DC_GENERATE_QTY = 'CREATE_USER_FORM_STITCHING_DC_GENERATE_QTY';


export const CREATE_BARCODE_TEMPLATES_REQUEST = 'CREATE_BARCODE_TEMPLATES_REQUEST'
export const CREATE_BARCODE_TEMPLATES_SUCCESS = 'CREATE_BARCODE_TEMPLATES_SUCCESS'
export const CREATE_BARCODE_TEMPLATES_FAILURE = 'CREATE_BARCODE_TEMPLATES_FAILURE'


export const CREATE_STITCHING_WITH_ACC_REQUEST = 'CREATE_STITCHING_WITH_ACC_REQUEST'
export const CREATE_STITCHING_WITH_ACC_SUCCESS = 'CREATE_STITCHING_WITH_ACC_SUCCESS'
export const CREATE_STITCHING_WITH_ACC_FAILURE = 'CREATE_STITCHING_WITH_ACC_FAILURE'




export const CREATE_STITCHING_WITH_ACC_POST_REQUEST = 'CREATE_STITCHING_WITH_ACC_POST_REQUEST'
export const CREATE_STITCHING_WITH_ACC_POST_SUCCESS = 'CREATE_STITCHING_WITH_ACC_POST_SUCCESS'
export const CREATE_STITCHING_WITH_ACC_POST_FAILURE = 'CREATE_STITCHING_WITH_ACC_POST_FAILURE'



export const STITCHING_DC_PROGRAM_ID_REQUEST = 'STITCHING_DC_PROGRAM_ID_REQUEST'
export const STITCHING_DC_PROGRAM_ID_SUCCESS = 'STITCHING_DC_PROGRAM_ID_SUCCESS'
export const STITCHING_DC_PROGRAM_ID_FAILURE = 'STITCHING_DC_PROGRAM_ID_FAILURE'



export const STITCHING_DC_WITH_ACC_REQUEST = 'STITCHING_DC_WITH_ACC_REQUEST'
export const STITCHING_DC_WITH_ACC_SUCCESS = 'STITCHING_DC_WITH_ACC_SUCCESS'
export const STITCHING_DC_WITH_ACC_FAILURE = 'STITCHING_DC_WITH_ACC_FAILURE'



export const CREATE_USER_FORM_STITCHING_DC_WITH_ACC_GENERATE_QTY = 'CREATE_USER_FORM_STITCHING_DC_WITH_ACC_GENERATE_QTY';



export const STITCHING_DC_WITH_ACC_REQUEST_POST = 'STITCHING_DC_WITH_ACC_REQUEST_POST'
export const STITCHING_DC_WITH_ACC_SUCCESS_POST = 'STITCHING_DC_WITH_ACC_SUCCESS_POST'
export const STITCHING_DC_WITH_ACC_FAILURE_POST = 'STITCHING_DC_WITH_ACC_FAILURE_POST'


export const CHECK_ALL_UPDATE_REQUEST = 'CHECK_ALL_UPDATE_REQUEST'
export const CHECK_ALL_UPDATE_SUCCESS = 'CHECK_ALL_UPDATE_SUCCESS'
export const CHECK_ALL_UPDATE_FAILURE = 'CHECK_ALL_UPDATE_FAILURE'


export const GET_DN_POST_REQUEST = 'GET_DN_POST_REQUEST'
export const GET_DN_POST_SUCCESS = 'GET_DN_POST_SUCCESS'
export const GET_DN_POST_FAILURE = 'GET_DN_POST_FAILURE'

export const FETCH_STITCHING_DC_DETAILS_DN_BY_ID_EDIT_QTY = 'FETCH_STITCHING_DC_DETAILS_DN_BY_ID_EDIT_QTY';


export const DELETE_CUTTING_DC_REQUEST_CALL_OFF_STITCHING = 'DELETE_CUTTING_DC_REQUEST_CALL_OFF_STITCHING'
export const DELETE_CUTTING_DC_SUCCESS_CALL_OFF_STITCHING = 'DELETE_CUTTING_DC_SUCCESS_CALL_OFF_STITCHING'
export const DELETE_CUTTING_DC_FAILURE_CALL_OFF_STITCHING = 'DELETE_CUTTING_DC_FAILURE_CALL_OFF_STITCHING'



export const STITCHING_DC_WITH_DN_PRINT_REQUEST = 'STITCHING_DC_WITH_DN_PRINT_REQUEST'
export const STITCHING_DC_WITH_DN_PRINT_SUCCESS = 'STITCHING_DC_WITH_DN_PRINT_SUCCESS'
export const STITCHING_DC_WITH_DN_PRINT_FAILURE = 'STITCHING_DC_WITH_DN_PRINT_FAILURE'

export const RELOAD_TO_DEFAULT_STATE_DN_PRINT = 'RELOAD_TO_DEFAULT_STATE_DN_PRINT'

export const CREATE_STITCHING_WITH_BARCODE_TOGGLE_REQUEST = 'CREATE_STITCHING_WITH_BARCODE_TOGGLE_REQUEST'
export const CREATE_STITCHING_WITH_BARCODE_TOGGLE_SUCCESS = 'CREATE_STITCHING_WITH_BARCODE_TOGGLE_SUCCESS'
export const CREATE_STITCHING_WITH_BARCODE_TOGGLE_FAILURE = 'CREATE_STITCHING_WITH_BARCODE_TOGGLE_FAILURE'

export const DELETE_STITCHING_ACCESSORIES_REQUEST = 'DELETE_STITCHING_ACCESSORIES_REQUEST'
export const DELETE_STITCHING_ACCESSORIES_SUCCESS = 'DELETE_STITCHING_ACCESSORIES_SUCCESS'
export const DELETE_STITCHING_ACCESSORIES_FAILURE = 'DELETE_STITCHING_ACCESSORIES_FAILURE'

export const DELETE_STITCHING_BARCODE_REQUEST = 'DELETE_STITCHING_BARCODE_REQUEST'
export const DELETE_STITCHING_BARCODE_SUCCESS = 'DELETE_STITCHING_BARCODE_SUCCESS'
export const DELETE_STITCHING_BARCODE_FAILURE = 'DELETE_STITCHING_BARCODE_FAILURE'

export const RESET_TO_RERVIOUS_LIST = 'RESET_TO_RERVIOUS_LIST'




export const STITCHING_PART_PRINTING_CHECK_REQUEST = 'STITCHING_PART_PRINTING_CHECK_REQUEST'
export const STITCHING_PART_PRINTING_CHECK_SUCCESS = 'STITCHING_PART_PRINTING_CHECK_SUCCESS'
export const STITCHING_PART_PRINTING_CHECK_FAILURE = 'STITCHING_PART_PRINTING_CHECK_FAILURE'



export const STITCHING_DC_WITH_DN_PRINT_CHECK_ENABLE_REQUEST = 'STITCHING_DC_WITH_DN_PRINT_CHECK_ENABLE_REQUEST'
export const STITCHING_DC_WITH_DN_PRINT_CHECK_ENABLE_SUCCESS = 'STITCHING_DC_WITH_DN_PRINT_CHECK_ENABLE_SUCCESS'
export const STITCHING_DC_WITH_DN_CHECK_ENABLE_PRINT_FAILURE = 'STITCHING_DC_WITH_DN_CHECK_ENABLE_PRINT_FAILURE'




export const STITCHING_DC_WITH_DN_PRINT_DELETE_REQUEST = 'STITCHING_DC_WITH_DN_PRINT_DELETE_REQUEST'
export const STITCHING_DC_WITH_DN_PRINT_DELETE_SUCCESS = 'STITCHING_DC_WITH_DN_PRINT_DELETE_SUCCESS'
export const STITCHING_DC_WITH_DN_PRINT_DELETE_FAILURE = 'STITCHING_DC_WITH_DN_PRINT_DELETE_FAILURE'

export const GET_TO_SEARCH_LIST = 'GET_TO_SEARCH_LIST'



export const STITCHING_DC_WITH_BUNDLE_GET_REQUEST = 'STITCHING_DC_WITH_BUNDLE_GET_REQUEST'
export const STITCHING_DC_WITH_BUNDLE_GET_SUCCESS = 'STITCHING_DC_WITH_BUNDLE_GET_SUCCESS'
export const STITCHING_DC_WITH_BUNDLE_GET_FAILURE = 'STITCHING_DC_WITH_BUNDLE_GET_FAILURE'



export const STITCHING_DC_WITH_BUNDLE_POST_REQUEST = 'STITCHING_DC_WITH_BUNDLE_POST_REQUEST'
export const STITCHING_DC_WITH_BUNDLE_POST_SUCCESS = 'STITCHING_DC_WITH_BUNDLE_POST_SUCCESS'
export const STITCHING_DC_WITH_BUNDLE_POST_FAILURE = 'STITCHING_DC_WITH_BUNDLE_POST_FAILURE'

export const STITCHING_DC_WITH_BUNDLE_POST_GET_REQUEST = 'STITCHING_DC_WITH_BUNDLE_POST_GET_REQUEST'
export const STITCHING_DC_WITH_BUNDLE_POST_GET_SUCCESS = 'STITCHING_DC_WITH_BUNDLE_POST_GET_SUCCESS'
export const STITCHING_DC_WITH_BUNDLE_POST_GET_FAILURE = 'STITCHING_DC_WITH_BUNDLE_POST_GET_FAILURE'
// export const PRINTING_DC_WITH_BUNDLE_POST_GET_SUCCESS = 'PRINTING_DC_WITH_BUNDLE_POST_GET_SUCCESS'


export const STITCHING_DC_WITH_BUNDLE_UPDATE_SELECTED_BUNDLE = 'STITCHING_DC_WITH_BUNDLE_UPDATE_SELECTED_BUNDLE'


export const UPDATE_STITCHING_BUNDLE_FILTER_INITIAL = 'UPDATE_STITCHING_BUNDLE_FILTER_INITIAL'


export const STITCHING_WITH_BUNDLE_RESET_DATA = 'STITCHING_WITH_BUNDLE_RESET_DATA'

export const STITCHING_DC_WITH_ADD_BTN = 'STITCHING_DC_WITH_ADD_BTN'

export const CREATE_STITCHING_WITH_BARCODE_TOGGLE_PRINT_REQUEST = 'CREATE_STITCHING_WITH_BARCODE_TOGGLE_PRINT_REQUEST'
export const CREATE_STITCHING_WITH_BARCODE_TOGGLE_PRINT_SUCCESS = 'CREATE_STITCHING_WITH_BARCODE_TOGGLE_PRINT_SUCCESS'
export const CREATE_STITCHING_WITH_BARCODE_TOGGLE_PRINT_FAILURE = 'CREATE_STITCHING_WITH_BARCODE_TOGGLE_PRINT_FAILURE'


export const STITCHING_DC_WITH_FOLDING_FABRIC_GET_REQUEST = 'STITCHING_DC_WITH_FOLDING_FABRIC_GET_REQUEST'
export const STITCHING_DC_WITH_FOLDING_FABRIC_GET_SUCCESS = 'STITCHING_DC_WITH_FOLDING_FABRIC_GET_SUCCESS'
export const STITCHING_DC_WITH_FOLDING_FABRIC_GET_FAILURE = 'STITCHING_DC_WITH_FOLDING_FABRIC_GET_FAILURE'




